// extracted by mini-css-extract-plugin
export var icon = "_7h-1";
export var subtext = "_7h-0";